// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1vIYh","amount":"Amount_amount__k-ksP","tip":"Amount_tip__3rSts","tipHeader":"Amount_tipHeader__1zmpk","tipsWrap":"Amount_tipsWrap__3jhY_"};